import { format } from 'date-fns';
import { Buffer } from 'buffer';
import { de, es, enUS, ptBR } from 'date-fns/locale';
import { getCDNImage } from './globals';
import { T } from 'react-translator-component';

export const isDate = (value) => {
    return !isNaN(new Date(value).getYear());
}

export const isObject = (value) => {
    return value !== null && typeof value === 'object';
}

export const formatDate = (date, withYear = true) => {
    if (!date) {
        return null;
    }
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    if (isNaN(date.getTime())) {
        return null;
    }
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - (offset * 60 * 1000));
    if (isNaN(date.getTime())) {
        return null;
    }
    date = date.toISOString().split('T')[0];
    if (!withYear) {
        const _arr = date.split('-').filter(p => parseInt(p) <= 31);
        date = _arr.join('-');
    }
    return date;
}


export const calculateDate = (date, days) => {
    const newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}

export function formatDayMonth(date, format = "MM-dd") {
    // console.log('19dic - format', format)
    if (format?.[0]) {
        format = format[0];
    }

    // console.log('19dic - format', date)
    const onlyDate = date.split('T');
    date = onlyDate[0];
    // console.log('19dic - format', date)

    const [year, month, day] = date.split('-'); // Divide la fecha en partes
    if (format === "MM-dd") {
        return `${month}-${day}`;
    }
    if (format === "dd-MM") {
        return `${day}-${month}`;
    }
    return `${month}-${day}`;
}

export const invertDate = dateStr => {
    if (typeof (dateStr) !== 'string') {
        return false;
    }
    return dateStr.split('-').reverse().join('-');
}

export const calculateAge = birthday => {
    if (!birthday) {
        return -1;
    }
    if (typeof birthday === 'string') {
        birthday = new Date(birthday);
    }
    if (isNaN(birthday.getTime())) {
        return -1;
    }
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs);

    const _age = Math.abs(ageDate.getUTCFullYear() - 1970);
    return !isNaN(_age) ? _age : -1;
}


export const currencyFormat = (num, currency = '$') => {
    if (isNaN(num)) return '-'
    const neg = num < 0
    // return (neg ? "(" : "") + currency + " " + Math.abs(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + (neg ? ")" : "")

    // Separamos la parte entera y decimal
    const [integerPart, decimalPart] = Math.abs(num).toString().split('.');

    return (
        (neg ? "(" : "") + // Si es negativo, agrega un paréntesis de apertura.
        currency + " " + // Agrega el símbolo de moneda.
        integerPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + // Usa puntos como separadores de miles.
        (decimalPart ? ',' + (decimalPart.length == 1 ? decimalPart + '0' : decimalPart) : '') + // Solo agrega la parte decimal si existe.
        (neg ? ")" : "") // Si es negativo, cierra con un paréntesis.
    );
}

export const priceWithoutTax = (price) => {
    let taxPercentage = 1.21;
    return parseInt(price / taxPercentage);
}

export const calculateHoursUntil = (date) => {
    const now = new Date();
    const auxDate = new Date(date);

    // Convertimos la diferencia de milisegundos a horas
    const differenceInHours = (auxDate - now) / (1000 * 60 * 60);

    return differenceInHours;
}

export const calculateDaysUntil = (date) => {
    const now = new Date();
    const [year, month, day] = date.split('-');
    const auxDate = new Date(year, month - 1, day);
    // Normalizamos las fechas a medianoche para evitar diferencias por horas
    now.setHours(0, 0, 0, 0);
    auxDate.setHours(0, 0, 0, 0);

    // Calculamos la diferencia en días
    const differenceInDays = (auxDate - now) / (1000 * 60 * 60 * 24);

    return differenceInDays;
};

const MAX_PLACEHOLDER_RESOLVE_DEPTH = 8;

const isPrimitiveOrNullish = (v) => (
    v === null || v === undefined
    || typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean'
);

/** Objeto cuyas propiedades son solo textos/números por código de idioma (CUSTOM-*, o hoja tras __MAIN__). */
const isLikelyLocaleLeafMap = (obj) => {
    if (!isObject(obj) || Array.isArray(obj)) {
        return false;
    }
    const keys = Object.keys(obj);
    if (keys.length === 0) {
        return false;
    }
    for (let i = 0; i < keys.length; i += 1) {
        if (!isPrimitiveOrNullish(obj[keys[i]])) {
            return false;
        }
    }
    return true;
};

const buildPlaceholderLangCandidates = (lang) => {
    const candidates = [];
    const add = (c) => {
        if (c != null && c !== '' && !candidates.includes(c)) {
            candidates.push(c);
        }
    };
    add(lang);
    if (lang === 'es' || lang === 'ES') {
        add('es');
        add('es-ES');
    }
    if (lang === 'es-ES') {
        add('es');
    }
    if (lang === 'de') {
        add('de-DE');
    }
    if (lang === 'fr') {
        add('fr-FR');
    }
    if (lang === 'pt' || lang === 'pt-BR') {
        add('pt-BR');
        add('pt');
    }
    if (lang === 'it' || lang === 'it-IT') {
        add('it-IT');
        add('it');
    }
    if (lang === 'en-US' || lang === 'US' || lang === 'en') {
        add('en-US');
        add('en');
        add('US');
    }
    add('default');
    add('en-US');
    return candidates;
};

const pickFromLocaleLeafMap = (raw, lang) => {
    const candidates = buildPlaceholderLangCandidates(lang);
    for (let i = 0; i < candidates.length; i += 1) {
        const k = candidates[i];
        const v = raw[k];
        if (v != null && String(v).trim() !== '') {
            return String(v);
        }
    }
    return '';
};

/**
 * Texto para sustituir [[TOKEN]]: soporta (1) mapa plano por idioma, (2) PROPERTY/UNIT con __MAIN__ u otras claves
 * y objeto anidado por idioma — retrocompatible con strings sueltos en settings.placeholders.
 */
export const resolvePlaceholderTokenValueForLang = (raw, lang, depth = 0) => {
    if (raw == null || depth > MAX_PLACEHOLDER_RESOLVE_DEPTH) {
        return '';
    }
    if (isPrimitiveOrNullish(raw)) {
        return String(raw);
    }
    if (Array.isArray(raw)) {
        return '';
    }
    const main = raw.__MAIN__ ?? raw.__main__;
    if (main != null && isObject(main) && !Array.isArray(main)) {
        const fromMain = resolvePlaceholderTokenValueForLang(main, lang, depth + 1);
        if (fromMain !== '') {
            return fromMain;
        }
    }
    const primitiveSlice = {};
    Object.keys(raw).forEach((k) => {
        if (isPrimitiveOrNullish(raw[k])) {
            primitiveSlice[k] = raw[k];
        }
    });
    if (Object.keys(primitiveSlice).length > 0) {
        const pickedSlice = pickFromLocaleLeafMap(primitiveSlice, lang);
        if (pickedSlice !== '') {
            return pickedSlice;
        }
    }
    if (isLikelyLocaleLeafMap(raw)) {
        return pickFromLocaleLeafMap(raw, lang);
    }
    const keys = Object.keys(raw).filter((k) => k !== '__MAIN__' && k !== '__main__');
    // Mapas custom (variantes cv_* + __fallback__): keys.sort() ponía "__fallback__" antes que "cv_*"
    // ( '_' < letras en ASCII ) y la PWA mostraba siempre el fallback si solo había datos del hotel.
    const fallbackLast = (a, b) => {
        const af = a === '__fallback__' ? 1 : 0;
        const bf = b === '__fallback__' ? 1 : 0;
        if (af !== bf) {
            return af - bf;
        }
        return String(a).localeCompare(String(b));
    };
    keys.sort(fallbackLast);
    for (let j = 0; j < keys.length; j += 1) {
        const child = raw[keys[j]];
        if (child != null && isObject(child) && !Array.isArray(child)) {
            const nested = resolvePlaceholderTokenValueForLang(child, lang, depth + 1);
            if (nested !== '') {
                return nested;
            }
        }
    }
    return '';
};

/** Mapa hotel + valores dinámicos del check-in (CUSTOM-*, UNIT-*, etc.); el check-in pisa claves del hotel. */
export const mergeHotelAndCheckinPlaceholders = (hotelPlaceholders, checkInPlaceholders) => {
    const base = hotelPlaceholders && typeof hotelPlaceholders === 'object' && !Array.isArray(hotelPlaceholders)
        ? { ...hotelPlaceholders }
        : {};
    if (checkInPlaceholders && typeof checkInPlaceholders === 'object' && !Array.isArray(checkInPlaceholders)) {
        Object.keys(checkInPlaceholders).forEach((k) => {
            base[k] = checkInPlaceholders[k];
        });
    }
    return base;
};

export const i18nValue = (data, key, lang, placeholders = null, defaultValue = "", defaultLanguage = null) => {

    // console.log(" ---------------- placeholders ----------------- ", placeholders);

    let _i18n = data && data[key + 'I18n'];
    if (typeof _i18n === "string") {
        _i18n = JSON.parse(data[key + 'I18n']);
        if (typeof _i18n === "string") {
            _i18n = JSON.parse(_i18n);
        }
    }
    let res = _i18n ? _i18n[lang] || _i18n['default'] || _i18n[defaultLanguage] || _i18n['en-US'] || (data && data[key]) || '' : '';
    if (placeholders && typeof placeholders === 'object' && !Array.isArray(placeholders)) {
        Object.keys(placeholders).forEach((el) => {
            const escaped = String(el).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const re = new RegExp(`\\[\\[${escaped}\\]\\]`, 'gi');
            let value = placeholders[el];
            let replaceWith;
            if (isObject(value)) {
                replaceWith = resolvePlaceholderTokenValueForLang(value, lang);
            } else {
                replaceWith = value;
                if (String(el).toUpperCase().includes("FILES-IMAGE") && replaceWith) {
                    console.log(`Procesando imagen: ${placeholders[el]}`);
                    replaceWith = `<img class='w-100' src="${getCDNImage(replaceWith)}" alt="${el}" />`;
                }
                if (String(el).toUpperCase().includes("FILES-BUTTON") && replaceWith) {
                    console.log(`Procesando button: ${placeholders[el]}`);
                    replaceWith = `<a class='mb-2 d-block w-100 text-center' href="${getCDNImage(replaceWith)}" target="_blank" style="color: rgb(85, 85, 85); border: 1px solid rgb(204, 204, 204); text-transform: uppercase; height: 50px; background-color: rgb(238, 238, 238); line-height: 50px; font-weight: bold; border-radius: 8px;">MENU</a>`;
                }
            }
            res = res.replace(re, () => {
                let out = replaceWith;
                if (out != null && isObject(out)) {
                    out = resolvePlaceholderTokenValueForLang(out, lang);
                }
                return out == null ? '' : String(out);
            });
        });
    }
    if (!res && defaultValue) {
        res = defaultValue;
    }
    return res;
};

// Normaliza el campo `preferences` de un item a objeto.
// La API lo devuelve como string JSON (p. ej. "{}" o "{\"id\":{...}}").
// Si se usara el string tal cual, Object.keys() iteraría cada caracter y
// generaria decenas de combos vacios en el carrito. Devuelve siempre un objeto.
export const parsePreferences = (preferences) => {
    if (!preferences) return {};
    let parsed = preferences;
    if (typeof parsed === "string") {
        try {
            parsed = JSON.parse(parsed);
        } catch (e) {
            return {};
        }
    }
    // Defensa ante doble-encoding
    if (typeof parsed === "string") {
        try {
            parsed = JSON.parse(parsed);
        } catch (e) {
            return {};
        }
    }
    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};
    return parsed;
};



export const getLastParamFromPath = (path) => {
    let _pathname = path;
    if (_pathname[_pathname.length - 1] == '/') {
        _pathname = _pathname.slice(0, -1);
    }
    _pathname = _pathname.split('/');
    return _pathname[_pathname.length - 1];
}

export const dataURLtoBlob = function (dataurl) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}

export const resizeImage = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async (event) => {
            const img = new Image();

            let dataURL = event.target.result;
            img.src = dataURL;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                const MAX_WIDTH = 1024;
                const MAX_HEIGHT = 1024;
                let width = img.width;
                let height = img.height;

                // Redimensionamiento de la imagen
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }

                // Establecer el tamaño del canvas y dibujar la imagen
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, width, height);

                // Convertir el canvas a un Blob
                canvas.toBlob((blob) => {
                    if (blob) {
                        resolve(blob);
                    } else {
                        reject(new Error('Failed to convert canvas to Blob'));
                    }
                }, 'image/jpeg');
            };

            img.onerror = (err) => {
                reject(new Error('Error loading image: ' + err));
            };
        };

        reader.onerror = (err) => {
            reject(new Error('Error reading file: ' + err));
        };
    });
};

export const formatDateFromLanguage = (date, language) => {
    console.log('2906 - language', language)
    let _format = 'MMM dd - HH:mm a';
    if (language === 'es') {
        _format = 'dd MMM - HH:mm a';
    }
    return format(new Date(date), _format)
}
export const formatTimeFromLanguage = (hhmm, language) => {
    // Asegura string de 4 dígitos
    let timeStr = hhmm.toString().padStart(4, '0');
    let hours = parseInt(timeStr.slice(0, 2), 10);
    let minutes = parseInt(timeStr.slice(2), 10);

    // Lista de idiomas que usan AM/PM
    const ampmLanguages = ['en', 'en-US', 'en-GB'];

    const isAmPm = ampmLanguages.includes(language);

    // Usa Intl.DateTimeFormat para que respete localización
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);

    const options = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: isAmPm,
    };

    let formatted = new Intl.DateTimeFormat(language, options).format(date);

    // Si es español, agregar "hs"
    if (language.startsWith('es')) {
        return `${formatted}hs.`;
    }

    return formatted;
}

export const encodeBase64 = (data) => {
    return Buffer.from(data).toString('base64');
}
export const decodeBase64 = (data) => {
    return Buffer.from(data, 'base64').toString('ascii');
}

export const getYear = (date) => {
    return date.getFullYear();
};
export const getMonth = (date) => {
    return date.getMonth();
};
export const range = (start, end, step = 1) => {
    const result = [];
    for (let i = start; i <= end; i += step) {
        result.push(i);
    }
    return result;
};

export const getLocale = (language) => {
    switch (language) {
        case 'es-ES':
            return es;
        case 'de':
            return de;
        case 'pt-BR':
            return ptBR;
        default:
            return enUS;
    }
};

export const getAvailableHours = (unavailableRanges) => {
    const totalRangeStart = 0;
    const totalRangeEnd = 24;

    // Obtener la hora actual (formato 24h)
    const currentHour = new Date().getHours();

    // Normalizar los rangos no disponibles
    const normalizedUnavailable = unavailableRanges
        .map((range) => {
            let [start, end] = range.split("-").map(Number);
            if (end <= start) {
                end += 24; // Ajustar rangos circulares como "15-00" a "15-24"
            }
            return { start, end };
        })
        .sort((a, b) => a.start - b.start);

    const availableRanges = [];
    let currentStart = totalRangeStart;

    // Calcular rangos disponibles
    for (const range of normalizedUnavailable) {
        if (currentStart < range.start) {
            availableRanges.push({ start: currentStart, end: range.start });
        }
        currentStart = Math.max(currentStart, range.end);
    }

    if (currentStart < totalRangeEnd) {
        availableRanges.push({ start: currentStart, end: totalRangeEnd });
    }

    // Determinar si la hora actual está deshabilitada
    const isDisabled = normalizedUnavailable.some(
        (range) => currentHour >= range.start && currentHour < range.end
    );

    // Ajustar los rangos disponibles al formato de 24 horas
    const adjustedAvailableRanges = availableRanges.map((range) => ({
        start: range.start % 24,
        end: range.end % 24,
    }));

    return {
        ranges: adjustedAvailableRanges.map(
            (range) => [`${range.start}`, `${range.end}`]
        ),
        isDisabled,
    };
};

export const getPluralKey = (count) => (count === 1 ? "one" : "other");

export const htmlToText = (html) => {
    let text = html;
    text = text.replace(/\n/gi, "");
    text = text.replace(/<style([\s\S]*?)<\/style>/gi, "");
    text = text.replace(/<script([\s\S]*?)<\/script>/gi, "");
    text = text.replace(/<a.*?href="(.*?)[\?\"].*?>(.*?)<\/a.*?>/gi, " $2 $1 ");
    text = text.replace(/<\/div>/gi, "\n\n");
    text = text.replace(/<\/li>/gi, "\n");
    text = text.replace(/<li.*?>/gi, "  *  ");
    text = text.replace(/<\/ul>/gi, "\n\n");
    text = text.replace(/<\/p>/gi, "\n\n");
    text = text.replace(/<br\s*[\/]?>/gi, "\n");
    text = text.replace(/<[^>]+>/gi, "");
    text = text.replace(/^\s*/gim, "");
    text = text.replace(/ ,/gi, ",");
    text = text.replace(/ +/gi, " ");
    text = text.replace(/\n+/gi, "\n\n");
    return text;
};

export const slugify = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim leading/trailing white space
    str = str.toLowerCase(); // convert string to lowercase
    str = str.replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    return str;
}

/** Código de reserva visible al huésped (confirmación), no externalId ni securityCode. */
export const reservationDisplayCode = (checkIn) =>
    checkIn?.code ?? checkIn?.reservation?.code ?? "";

export const roomData = (checkIn, lang) => {
    let res = { name: "", description: "" };
    if (checkIn) {
        res.name = checkIn?.RoomCategory ?? ""
        res.description = checkIn?.reservation?.unitGroup?.description ?? "";
        if (checkIn?.RoomCategory) {
            res.name = i18nValue(checkIn?.RoomCategory, "name", lang);
            res.description = i18nValue(checkIn?.RoomCategory, "description", lang);
        }
    }
    return res;
}

export const qtyText = (qtyTotal, qtyAdults = 0, qtyChildren = 0) => {
    const isValid = Number.isInteger(qtyAdults) && Number.isInteger(qtyChildren);
    if (!isValid) {
        return `${qtyTotal} ${T(qtyTotal > 1 ? "public.reservation.adults" : "public.reservation.adult")}`;
    }
    return `${qtyAdults} ${T(qtyAdults > 1 ? "public.reservation.adults" : "public.reservation.adult")} - ${qtyChildren} ${T(qtyChildren > 1 ? "public.reservation.children" : "public.reservation.child")}`;
}

// Función para convertir tiempo HH:MM a minutos
export const timeToMinutes = (time) => {
    if (!time) return 0;
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
};

// Función para convertir minutos a formato HH:MM
export const minutesToTime = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return `${String(hours).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

// Función para obtener el nombre del día actual en inglés (para acceder a unavailableSlots)
export const getTodayDayName = () => {
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const today = new Date();
    return days[today.getDay()];
};

// Función para formatear los horarios disponibles
export const formatAvailableHours = (startHour, endHour, unavailableSlots, duration = 60) => {
    if (!startHour || !endHour || !unavailableSlots) {
        return {
            dayName: getTodayDayName(),
            availableRanges: [`${startHour} - ${endHour}`]
        };
    }

    // Obtener los slots no disponibles para hoy
    const todayDayName = getTodayDayName();
    const todayUnavailableSlots = unavailableSlots[todayDayName] || [];

    // Si no hay slots no disponibles, mostrar el rango completo
    if (todayUnavailableSlots.length === 0) {
        return {
            dayName: todayDayName,
            availableRanges: [`${startHour} - ${endHour}`]
        };
    }

    // Convertir a minutos para facilitar los cálculos
    const startMinutes = timeToMinutes(startHour);
    const endMinutes = timeToMinutes(endHour);
    const unavailableMinutes = todayUnavailableSlots.map(slot => timeToMinutes(slot)).sort((a, b) => a - b);
    const durationMinutes = duration || 60;

    // Crear array de rangos disponibles
    const availableRanges = [];
    let currentStart = startMinutes;

    unavailableMinutes.forEach(unavailableStart => {
        // Si hay espacio entre el inicio actual y el slot no disponible
        if (currentStart < unavailableStart) {
            availableRanges.push({
                start: currentStart,
                end: unavailableStart
            });
        }
        // Avanzar al final del slot no disponible + duración
        currentStart = unavailableStart + durationMinutes;
    });

    // Agregar el último rango si hay espacio
    if (currentStart < endMinutes) {
        availableRanges.push({
            start: currentStart,
            end: endMinutes
        });
    }

    // Formatear el resultado
    if (availableRanges.length === 0) {
        return {
            dayName: todayDayName,
            availableRanges: [T('public_cart.no-available-hours')]
        };
    }

    return {
        dayName: todayDayName,
        availableRanges: availableRanges.map(range => `${minutesToTime(range.start)} - ${minutesToTime(range.end)}`)
    };
};

